import { render, staticRenderFns } from "./JournalConfigEdit.vue?vue&type=template&id=5e53240a"
import script from "./JournalConfigEdit.vue?vue&type=script&lang=ts"
export * from "./JournalConfigEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e53240a')) {
      api.createRecord('5e53240a', component.options)
    } else {
      api.reload('5e53240a', component.options)
    }
    module.hot.accept("./JournalConfigEdit.vue?vue&type=template&id=5e53240a", function () {
      api.rerender('5e53240a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/JournalConfigEdit.vue"
export default component.exports